var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Attach the properties of `props` to `value`.
 * This is equivalent to Object.assign(value, props), but
 * produces a typing union of value and props.
 */
export function attachProps(value, props) {
    return Object.assign(value, props);
}
/**
 * Produces a classname list from the array of classNames.
 * Any falsy value is filtered out of the final concatination.
 */
export function classnames() {
    var _a;
    var classNames = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classNames[_i] = arguments[_i];
    }
    classNames = (_a = []).concat.apply(_a, __spreadArray([], __read(classNames), false));
    return classNames.filter(function (x) { return Boolean(x); }).join(" ");
}
/**
 * Generates a data-test attribute which can be used with Nightwatch
 */
export var generateTestId = function (str) {
    var _a;
    return (_a = {},
        _a["data-test-".concat(str)] = true,
        _a);
};
/**
 * Takes a MaybeArray, and converts it to an array.
 *
 * If the value is an array, the array is returned.
 * If the value is not an array, a new array is returned containing
 * the given item.
 * @param x The MaybeArray to convert to an array.
 */
export function maybeToArray(x) {
    return Array.isArray(x) ? x : [x];
}
/**
 * Returns true if the value is not null.
 *
 * This function informs typescript that the specified value cannot be null, and is useful
 * for array filtering.
 * @param x The value to check.
 */
export function isNotNull(x) {
    return x != null;
}
export function isRefObject(x) {
    return x && typeof x === "object" && "current" in x;
}
export function maybeToElement(x) {
    if (isRefObject(x)) {
        return x.current;
    }
    return x;
}
//# sourceMappingURL=utils.js.map